import React from 'react';
import { Loader } from 'lucide-react';

interface LoadingSpinnerProps {
  title?: string;
  message?: string;
  size?: 'small' | 'medium' | 'large';
  fullScreen?: boolean;
  className?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  title = 'Loading',
  message = 'Please wait while we fetch your data...',
  size = 'large',
  fullScreen = true,
  className = ''
}) => {
  const sizeClasses = {
    small: 'w-4 h-4',
    medium: 'w-8 h-8', 
    large: 'w-12 h-12'
  };

  const textSizeClasses = {
    small: { title: 'text-sm', message: 'text-xs' },
    medium: { title: 'text-lg', message: 'text-sm' },
    large: { title: 'text-xl', message: 'text-base' }
  };

  if (fullScreen) {
    return (
      <div className={`pt-16 ml-64 ${className}`}>
        <div className="flex items-center justify-center" style={{ minHeight: 'calc(100vh - 4rem)' }}>
          <div className="text-center">
            <div className="flex justify-center mb-4">
              <Loader className={`${sizeClasses[size]} text-blue-500 animate-spin`} />
            </div>
            <h2 className={`${textSizeClasses[size].title} font-semibold text-gray-700 mb-2`}>
              {title}
            </h2>
            <p className={`${textSizeClasses[size].message} text-gray-500`}>
              {message}
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`flex items-center justify-center p-4 ${className}`}>
      <div className="text-center">
        <div className="flex justify-center mb-2">
          <Loader className={`${sizeClasses[size]} text-blue-500 animate-spin`} />
        </div>
        {size !== 'small' && (
          <>
            <h3 className={`${textSizeClasses[size].title} font-semibold text-gray-700 mb-1`}>
              {title}
            </h3>
            <p className={`${textSizeClasses[size].message} text-gray-500`}>
              {message}
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default LoadingSpinner;